/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_Private_ModelsInputs */



/**
* | output |
* | --- |
* | "Host and manage your own AI models with full control over data residency." |
*
* @param {Plan_Gate_Desc_Private_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_private_models = /** @type {((inputs?: Plan_Gate_Desc_Private_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_Private_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hosten und verwalten Sie Ihre eigenen KI-Modelle mit voller Kontrolle über den Datenstandort.")
	return /** @type {LocalizedString} */ ("Host and manage your own AI models with full control over data residency.")
});